// extracted by mini-css-extract-plugin
module.exports = {"title":"CryptoPopular_title__SXU3e"};